/* eslint-disable react/prop-types */
import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const EquisClose = ({
    title = "Equis icon",
    ...props
}: Props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            role={props?.role as string || "img"}
            aria-label={title}
            fill="black"
        >
            <title>{title}</title>
            <path d="M12.5 14.0287L4.85632 21.6724C4.63793 21.8908 4.38314 22 4.09194 22C3.80077 22 3.54598 21.8908 3.32757 21.6724C3.1092 21.454 3 21.1992 3 20.908C3 20.6168 3.1092 20.3621 3.32757 20.1436L10.9713 12.5L3.32757 4.85632C3.1092 4.6379 3 4.38313 3 4.09196C3 3.80075 3.1092 3.54598 3.32757 3.32761C3.54598 3.10919 3.80077 3 4.09194 3C4.38314 3 4.63793 3.10919 4.85632 3.32761L12.5 10.9712L20.1437 3.32761C20.3621 3.10919 20.6168 3 20.908 3C21.1992 3 21.454 3.10919 21.6724 3.32761C21.8908 3.54598 22 3.80075 22 4.09196C22 4.38313 21.8908 4.6379 21.6724 4.85632L14.0287 12.5L21.6724 20.1436C21.8908 20.3621 22 20.6168 22 20.908C22 21.1992 21.8908 21.454 21.6724 21.6724C21.454 21.8908 21.1992 22 20.908 22C20.6168 22 20.3621 21.8908 20.1437 21.6724L12.5 14.0287Z" />
        </svg>
    );
};

export default EquisClose;
